<template>
    <div>
        <v-container fluid class="d-print-none">
            <v-row no-gutters>
                <v-col :cols="12">
                    <h1 class="headline font-weight-light mb-3">
                        Export Report
                    </h1>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12" sm="6">
                    <!-- max-width="500" -->

                    <v-card>
                        <v-container fluid>
                            <v-row>
                                <v-col cols="12">
                                    <v-autocomplete
                                        chips
                                        v-model="form_search.project"
                                        :items="data_filter.projects"
                                        :search-input.sync="search"
                                        label="Select Project"
                                        item-text="project_name"
                                        item-value="project_id"
                                        multiple
                                    >
                                        <template
                                            v-slot:selection="{ item, index }"
                                        >
                                            <v-chip v-if="index === 0">
                                                <span>{{
                                                    item.project_name
                                                }}</span>
                                            </v-chip>
                                            <span
                                                v-if="index === 1"
                                                class="grey--text caption"
                                                >(+{{
                                                    form_search.project.length -
                                                        1
                                                }}
                                                others)</span
                                            >
                                        </template>
                                        <template v-slot:prepend-item>
                                            <v-list-item ripple @click="toggle">
                                                <v-list-item-action>
                                                    <v-icon
                                                        :color="
                                                            form_search.project
                                                                .length > 0
                                                                ? 'indigo darken-4'
                                                                : ''
                                                        "
                                                        >{{ icon }}</v-icon
                                                    >
                                                </v-list-item-action>
                                                <v-list-item-content>
                                                    <v-list-item-title
                                                        >Select
                                                        All</v-list-item-title
                                                    >
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-divider class="mt-2"></v-divider>
                                        </template>

                                        <template v-slot:append-item>
                                            <v-divider class="mb-2"></v-divider>
                                            <v-list-item disabled>
                                                <v-list-item-avatar
                                                    color="grey lighten-3"
                                                >
                                                    <v-icon
                                                        >mdi-folder-plus</v-icon
                                                    >
                                                </v-list-item-avatar>

                                                <v-list-item-content
                                                    v-if="likesAllProject"
                                                >
                                                    <v-list-item-title
                                                        >Select All
                                                        Project</v-list-item-title
                                                    >
                                                </v-list-item-content>

                                                <v-list-item-content
                                                    v-else-if="likesSomeProject"
                                                >
                                                    <v-list-item-title
                                                        >Project
                                                        Count</v-list-item-title
                                                    >
                                                    <v-list-item-subtitle>{{
                                                        form_search.project
                                                            .length
                                                    }}</v-list-item-subtitle>
                                                </v-list-item-content>

                                                <v-list-item-content v-else>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </template>
                                    </v-autocomplete>
                                </v-col>

                                <v-col cols="12" class="mar-t-20">
                                    <v-autocomplete
                                        chips
                                        v-model="form_search.zone"
                                        :items="data_filter.branchs"
                                        label="Select Zone"
                                        item-text="branch_name"
                                        item-value="branch_id"
                                        multiple
                                    >
                                        <template
                                            v-slot:selection="{ item, index }"
                                        >
                                            <v-chip v-if="index === 0">
                                                <span>{{
                                                    item.branch_name
                                                }}</span>
                                            </v-chip>
                                            <span
                                                v-if="index === 1"
                                                class="grey--text caption"
                                                >(+{{
                                                    form_search.zone.length - 1
                                                }}
                                                others)</span
                                            >
                                        </template>
                                        <template v-slot:prepend-item>
                                            <v-list-item
                                                ripple
                                                @click="toggle_zone"
                                            >
                                                <v-list-item-action>
                                                    <v-icon
                                                        :color="
                                                            form_search.zone
                                                                .length > 0
                                                                ? 'indigo darken-4'
                                                                : ''
                                                        "
                                                        >{{ icon_zone }}</v-icon
                                                    >
                                                </v-list-item-action>
                                                <v-list-item-content>
                                                    <v-list-item-title
                                                        >Select
                                                        All</v-list-item-title
                                                    >
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-divider class="mt-2"></v-divider>
                                        </template>
                                        <template v-slot:append-item>
                                            <v-divider class="mb-2"></v-divider>
                                            <v-list-item disabled>
                                                <v-list-item-avatar
                                                    color="grey lighten-3"
                                                >
                                                    <v-icon
                                                        >mdi-folder-plus</v-icon
                                                    >
                                                </v-list-item-avatar>

                                                <v-list-item-content
                                                    v-if="likesAllZone"
                                                >
                                                    <v-list-item-title
                                                        >Select All
                                                        Zone</v-list-item-title
                                                    >
                                                </v-list-item-content>

                                                <v-list-item-content
                                                    v-else-if="likesSomeZone"
                                                >
                                                    <v-list-item-title
                                                        >Zone
                                                        Count</v-list-item-title
                                                    >
                                                    <v-list-item-subtitle>{{
                                                        form_search.zone.length
                                                    }}</v-list-item-subtitle>
                                                </v-list-item-content>

                                                <v-list-item-content v-else>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </template>
                                    </v-autocomplete>
                                </v-col>

                                <v-col cols="12" class="mar-t-20">
                                    <v-autocomplete
                                        chips
                                        v-model="form_search.status"
                                        :items="data_filter.status"
                                        label="Select Status"
                                        multiple
                                    >
                                        <template
                                            v-slot:selection="{ item, index }"
                                        >
                                            <v-chip v-if="index === 0">
                                                <span>{{ item }}</span>
                                            </v-chip>
                                            <span
                                                v-if="index === 1"
                                                class="grey--text caption"
                                                >(+{{
                                                    form_search.status.length -
                                                        1
                                                }}
                                                others)</span
                                            >
                                        </template>
                                        <template v-slot:prepend-item>
                                            <v-list-item
                                                ripple
                                                @click="toggle_status"
                                            >
                                                <v-list-item-action>
                                                    <v-icon
                                                        :color="
                                                            form_search.status
                                                                .length > 0
                                                                ? 'indigo darken-4'
                                                                : ''
                                                        "
                                                        >{{
                                                            icon_status
                                                        }}</v-icon
                                                    >
                                                </v-list-item-action>
                                                <v-list-item-content>
                                                    <v-list-item-title
                                                        >Select
                                                        All</v-list-item-title
                                                    >
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-divider class="mt-2"></v-divider>
                                        </template>
                                        <template v-slot:append-item>
                                            <v-divider class="mb-2"></v-divider>
                                            <v-list-item disabled>
                                                <v-list-item-avatar
                                                    color="grey lighten-3"
                                                >
                                                    <v-icon
                                                        >mdi-folder-plus</v-icon
                                                    >
                                                </v-list-item-avatar>

                                                <v-list-item-content
                                                    v-if="likesAllStatus"
                                                >
                                                    <v-list-item-title
                                                        >Select All
                                                        Status</v-list-item-title
                                                    >
                                                </v-list-item-content>

                                                <v-list-item-content
                                                    v-else-if="likesSomeStatus"
                                                >
                                                    <v-list-item-title
                                                        >Status
                                                        Count</v-list-item-title
                                                    >
                                                    <v-list-item-subtitle>{{
                                                        form_search.status
                                                            .length
                                                    }}</v-list-item-subtitle>
                                                </v-list-item-content>

                                                <v-list-item-content v-else>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </template>
                                    </v-autocomplete>
                                </v-col>

                                <v-col cols="12">
                                    <v-progress-linear
                                        v-if="chk_export === true"
                                        indeterminate
                                        color="cyan"
                                    ></v-progress-linear>
                                    <v-btn
                                        v-if="chk_export === false"
                                        block
                                        color="green accent-3"
                                        class="mt-4"
                                        @click="export_data()"
                                        :disabled="
                                            form_search.project == '' ||
                                                form_search.zone == '' ||
                                                form_search.status == ''
                                        "
                                    >
                                        Export Data
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card>
                </v-col>

                <v-col cols="12" sm="6">
                    <v-form method="post" id="nativeForm" v-model="valid2">
                        <!-- max-width="500" -->
                        <v-card>
                            <v-container fluid>
                                <v-row>
                                    <v-col cols="12" class="mt-2">
                                        <v-autocomplete
                                            :items="data_filter.activities"
                                            v-model="form_search2.activities"
                                            menu-props="auto"
                                            label="Select Activities"
                                            hide-details
                                        ></v-autocomplete>
                                    </v-col>
                                    <v-col cols="12" class="mt-1">
                                        <v-autocomplete
                                            chips
                                            v-model="form_search2.project"
                                            :items="data_filter.projects"
                                            label="Select Project"
                                            item-text="project_name"
                                            item-value="project_id"
                                            multiple
                                        >
                                            <template
                                                v-slot:selection="{
                                                    item,
                                                    index,
                                                }"
                                            >
                                                <v-chip v-if="index === 0">
                                                    <span>{{
                                                        item.project_name
                                                    }}</span>
                                                </v-chip>
                                                <span
                                                    v-if="index === 1"
                                                    class="grey--text caption"
                                                    >(+{{
                                                        form_search2.project
                                                            .length - 1
                                                    }}
                                                    others)</span
                                                >
                                            </template>
                                            <template v-slot:prepend-item>
                                                <v-list-item
                                                    ripple
                                                    @click="toggle2"
                                                >
                                                    <v-list-item-action>
                                                        <v-icon
                                                            :color="
                                                                form_search2
                                                                    .project
                                                                    .length > 0
                                                                    ? 'indigo darken-4'
                                                                    : ''
                                                            "
                                                            >{{ icon2 }}</v-icon
                                                        >
                                                    </v-list-item-action>
                                                    <v-list-item-content>
                                                        <v-list-item-title
                                                            >Select
                                                            All</v-list-item-title
                                                        >
                                                    </v-list-item-content>
                                                </v-list-item>
                                                <v-divider
                                                    class="mt-2"
                                                ></v-divider>
                                            </template>

                                            <template v-slot:append-item>
                                                <v-divider
                                                    class="mb-2"
                                                ></v-divider>
                                                <v-list-item disabled>
                                                    <v-list-item-avatar
                                                        color="grey lighten-3"
                                                    >
                                                        <v-icon
                                                            >mdi-folder-plus</v-icon
                                                        >
                                                    </v-list-item-avatar>

                                                    <v-list-item-content
                                                        v-if="likesAllProject2"
                                                    >
                                                        <v-list-item-title
                                                            >Select All
                                                            Project</v-list-item-title
                                                        >
                                                    </v-list-item-content>

                                                    <v-list-item-content
                                                        v-else-if="
                                                            likesSomeProject2
                                                        "
                                                    >
                                                        <v-list-item-title
                                                            >Project
                                                            Count</v-list-item-title
                                                        >
                                                        <v-list-item-subtitle>{{
                                                            form_search2.project
                                                                .length
                                                        }}</v-list-item-subtitle>
                                                    </v-list-item-content>

                                                    <v-list-item-content v-else>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </template>
                                        </v-autocomplete>
                                    </v-col>

                                    <v-col cols="12" class="mar-t-10">
                                        <v-menu
                                            v-model="modal"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            transition="scale-transition"
                                            offset-y
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                    v-model="dateRangeText"
                                                    label="Date range"
                                                    readonly
                                                    v-on="on"
                                                    :rules="dateR"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                style="
                                                    min-width: 0px !important;
                                                "
                                                v-model="form_search2.dates"
                                                range
                                                @change="get_date()"
                                            ></v-date-picker>
                                        </v-menu>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-progress-linear
                                            v-if="chk_export2 === true"
                                            indeterminate
                                            color="cyan"
                                        ></v-progress-linear>
                                        <v-btn
                                            v-if="chk_export2 === false"
                                            block
                                            color="green accent-3"
                                            class="mt-4"
                                            @click="export_data2()"
                                            :disabled="
                                                !valid2 ||
                                                    form_search2.activities ==
                                                        '' ||
                                                    form_search2.project == ''
                                            "
                                        >
                                            Export Data
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card>
                    </v-form>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
import axios from "axios"

const url = `${process.env.VUE_APP_ROOT_API}/api/`
import { mapState, mapMutations } from "vuex"

export default {
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
    },
    mounted() {
        this.get_filter()
    },
    computed: {
        ...mapState(["isLoading"]),

        likesAllProject() {
            return (
                this.form_search.project.length ===
                this.data_filter.projects.length
            )
        },
        likesSomeProject() {
            return this.form_search.project.length > 0 && !this.likesAllProject
        },
        icon() {
            if (this.likesAllProject) return "mdi-close-box"
            if (this.likesSomeProject) return "mdi-minus-box"
            return "mdi-checkbox-blank-outline"
        },

        likesAllProject2() {
            return (
                this.form_search2.project.length ===
                this.data_filter.projects.length
            )
        },
        likesSomeProject2() {
            return (
                this.form_search2.project.length > 0 && !this.likesAllProject2
            )
        },
        icon2() {
            if (this.likesAllProject2) return "mdi-close-box"
            if (this.likesSomeProject2) return "mdi-minus-box"
            return "mdi-checkbox-blank-outline"
        },

        likesAllZone() {
            return (
                this.form_search.zone.length === this.data_filter.branchs.length
            )
        },
        likesSomeZone() {
            return this.form_search.zone.length > 0 && !this.likesAllZone
        },
        icon_zone() {
            if (this.likesAllZone) return "mdi-close-box"
            if (this.likesSomeZone) return "mdi-minus-box"
            return "mdi-checkbox-blank-outline"
        },

        likesAllStatus() {
            return (
                this.form_search.status.length ===
                this.data_filter.status.length
            )
        },
        likesSomeStatus() {
            return this.form_search.status.length > 0 && !this.likesAllStatus
        },
        icon_status() {
            if (this.likesAllStatus) return "mdi-close-box"
            if (this.likesSomeStatus) return "mdi-minus-box"
            return "mdi-checkbox-blank-outline"
        },
        dateRangeText() {
            this.form_search2.dates.sort((a, b) => {
                return new Date(a) - new Date(b)
            })

            return this.form_search2.dates.join(" ~ ")
        },
    },
    methods: {
        ...mapMutations(["mutateIsLoading"]),
        async get_filter() {
            this.mutateIsLoading()
            await axios
                .get(url + "inventory/report", this.tk)
                .then((response) => {
                    //ที่ทำ state แยกแบบนี้เพราะแก้การ error .length
                    this.data_filter.activities = response.data.activities
                    this.data_filter.branchs = response.data.branchs
                    this.data_filter.projects = response.data.projects
                    this.data_filter.status = response.data.status

                    this.mutateIsLoading()
                })
        },
        get_date() {
            if (this.dateRangeText.length === 23) {
                this.modal = false
            }
        },
        toggle() {
            this.$nextTick(() => {
                if (this.likesAllProject) {
                    this.form_search.project = []
                } else {
                    // this.form_search.project = this.data_filter.projects.slice()
                    this.form_search.project = []
                    this.data_filter.projects.map((each) => {
                        this.form_search.project.push(each.project_id)
                    })
                }
            })
        },
        toggle2() {
            this.$nextTick(() => {
                if (this.likesAllProject2) {
                    this.form_search2.project = []
                } else {
                    // this.form_search2.project = this.data_filter.projects.slice()
                    this.form_search2.project = []
                    this.data_filter.projects.map((each) => {
                        this.form_search2.project.push(each.project_id)
                    })
                }
            })
        },
        toggle_zone() {
            this.$nextTick(() => {
                if (this.likesAllZone) {
                    this.form_search.zone = []
                } else {
                    // this.form_search.zone = this.data_filter.branchs.slice()
                    this.form_search.zone = []
                    this.data_filter.branchs.map((each) => {
                        this.form_search.zone.push(each.branch_id)
                    })
                }
            })
        },
        toggle_status() {
            this.$nextTick(() => {
                if (this.likesAllStatus) {
                    this.form_search.status = []
                } else {
                    // this.form_search.zone = this.data_filter.branchs.slice()
                    this.form_search.status = []
                    this.data_filter.status.map((each) => {
                        this.form_search.status.push(each)
                    })
                }
            })
        },
        async export_data() {
            this.chk_export = true
            await axios({
                url: url + "inventory/report-raw",
                method: "POST",
                responseType: "blob",
                data: this.form_search,
                headers: { Authorization: "Bearer " + localStorage.token },
            }).then((response) => {
                // console.log(response)
                let fileURL = window.URL.createObjectURL(
                    new Blob([response.data])
                )
                let fileLink = document.createElement("a")

                fileLink.href = fileURL
                fileLink.setAttribute("download", "report.xlsx")
                document.body.appendChild(fileLink)

                fileLink.click()
                this.chk_export = false
            })
        },
        async export_data2() {
            console.log(this.form_search2)
            this.chk_export2 = true
            await axios({
                url: url + "inventory/report-activity",
                method: "POST",
                responseType: "blob",
                data: this.form_search2,
                headers: { Authorization: "Bearer " + localStorage.token },
            }).then((response) => {
                // console.log(response)
                let fileURL = window.URL.createObjectURL(
                    new Blob([response.data])
                )
                let fileLink = document.createElement("a")

                fileLink.href = fileURL
                fileLink.setAttribute("download", "report.xlsx")
                document.body.appendChild(fileLink)

                fileLink.click()
                this.chk_export2 = false
            })
        },
    },
    data() {
        return {
            chk_export: false,
            chk_export2: false,
            tk: null,
            data_filter: {
                activities: [],
                branchs: [],
                projects: [],
                status: [],
            },
            modal: false,
            form_search: {
                project: [],
                zone: [],
                status: [],
            },
            form_search2: {
                project: [],
                activities: null,
                dates: [],
            },
            valid2: false,
            dateR: [(v) => !!v || "Dates is required"],
            team_name: localStorage.team_name,
            search: null,
        }
    },
}
</script>
